import type { FaireProductEntity } from "../../entity_types/product";

export const p_56umj2kasr: FaireProductEntity = {
  token: "p_56umj2kasr",
  type: "product",
  name: "Mauve | Organic Gown",
  brandToken: "b_ah4p50x0",
  brandName: "L'ovedbaby",
  imageUrl:
    "https://cdn.faire.com/fastly/459cdced59f115da5b258efd14249418884ca45f8a9fc6d98536e9c6fab2f976.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c55fc99f1f7a93c2e6eacdd8e9a0c331444a9b7e6dbfbe36afef317f99b3c1ab.jpeg",
  ],
  priceDollars: 16,
  description:
    "* GOTS certified 100% organic cotton \n * a body-hugging fit and 4-snap chest panel for easy dressing \n * soft elastic bottom to make those constant diaper changes a breeze \n * fold-over, mitt-sleeves for added warmth and protection from self-scratching *Please note that babies need sensory exploration and tactile stimulation every day, so be sure to leave little hands uncovered for a portion of the day :-) \n * pairs perfectly with our cap and blanket for a cozy outfit during those first few months of life \n * chrome/lead/nickel-free snaps \n * tagless for added comfort against baby's skin \n * azo-free, non-toxic, eco-friendly dyes \n * ethically made in India \n * machine wash/dry \n * we cut a little long to account for some shrinkage in length that may occur in the dryer",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:17.021Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
